<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <template v-if="checkSessionRoleId === '1'">
        <div class="p-15">
          <div class="row">
            <div class="col-sm-7">
              <a v-if="getRoleId != '33'" @click="openPage('/membership/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
            </div>
            <div class="col-sm-5">
            <b-row>
                <b-col sm="3">
                  <label style="margin-top: 5px;">Branch</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <hr class="mb-0 mt-0">
      </template>
      <div class="p-15">
        <template v-if="getRoleId === '2'">
          <div class="row">
            <div class="col-md-4 mb-20">
              <div class="box-membership">
                <div class="mb-10">
                  <img class="w-100" :src="parseImg(imageMembership)" alt="">
                </div>
                <div class="color-primary font-500 font-16 mb-5">{{items.name}}</div>
                <div v-if="items.membership_type_id == 2"><span class="badge-membership">Yearly</span></div>
                <div v-else><span class="badge-membership">Monthly</span></div>
                <div class="mt-5 mb-10">
                  <table class="w-100 font-300">
                    <tr>
                      <td>Monthly Price</td>
                      <td>Rp. {{row.price}}</td>
                    </tr>
                    <tr>
                      <td>Processing Fee</td>
                      <td>Rp. {{row.processing_fee}}</td>
                    </tr>
                  </table>
                </div>
                <div class="mb-10 font-300">{{items.description}}</div>
                <div v-if="checkSessionRoleId === '1' || checkSessionRoleId === '2'">
                  <b-button size="sm" @click="editData('/membership/edit?id=' + items.id)" class="btn-table primary w-100"><i class="far fa-edit"></i> Edit
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-md-4 mb-20" v-for="row in itemsMembership" :key="row.id">
              <div class="box-membership">
                <div class="mb-10">
                  <img class="w-100" :src="parseImg(row.thumbnail)" alt="">
                </div>
                <div class="color-primary font-500 font-16 mb-5">{{row.name}}</div>
                <div v-if="row.membership_type_id == 2"><span class="badge-membership">Yearly</span></div>
                <div v-else><span class="badge-membership">Monthly</span></div>
                <div class="mt-5 mb-10">
                  <table class="w-100 font-300">
                    <tr>
                      <td>Monthly Price</td>
                      <td>Rp. {{row.price}}</td>
                    </tr>
                    <tr>
                      <td>Processing Fee</td>
                      <td>Rp. {{row.processing_fee}}</td>
                    </tr>
                  </table>
                </div>
                <div class="mb-10 font-300">{{row.description}}</div>
                <div v-if="checkSessionRoleId === '1'">
                  <b-button size="sm" @click="editData('/membership/edit?id=' + row.id)" class="btn-table primary w-100"><i class="far fa-edit"></i> Edit
                  </b-button>
                  <b-button size="sm" @click="deleteData(row.id)" class="btn-black mt-5 w-100">
                    <i class="fas fa-times"></i> Delete
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'event',
  data: () => {
    return {
      checkSessionRoleId: '',
      items: [],
      getRoleId: Auth.Session.get().paradigm_role,
      itemsMembership: [],
      imageMembership: '',
      dataBranch: [],
      branch_id: null
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeBranch(event) {
      this.fetchData()
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    parseImg (value) {
      if (value === '' || value === undefined) {
        return '/img/default.png'
      } else {
        return Auth.apiUrl + 'fitness/v1/img/membership/' + value
      }
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editData (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/membership/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/membership/1').then(response => {
        this.items = response.data.data
        this.imageMembership = response.data.data.thumbnail
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      const set_branch_id = this.branch_id == null ? '' : this.branch_id
      axios.get('fitness/v1/membership?branch_id='+set_branch_id).then(response => {
        this.itemsMembership = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.checkSessionRoleId = Auth.Session.get().paradigm_role
    this.fetchData()
  }
}
</script>

<style>
</style>
